export const ExternalMenuItems = {
  CUSTOMER: {
    TRACK_AND_TRACE: 'Track and Trace',
    SCHEDULE_SHIPMENT: 'Schedule Shipment',
    RATE_REQUEST: 'Rate Request',
    RATE_INQUIRY: 'Rate Inquiry',
    FREIGHT_ANALYTICS: 'Freight Analytics',
    MY_NETWORK: 'My Network',
    MY_ACCOUNT: 'My Account',
    INVOICES: 'Invoices'
  },
  SUPPLIER: {
    PURCHASE_ORDER: 'Purchase Orders',
    WORK_LIST: 'Work List'
  },
  CARRIER: {
    INVOICES: 'Invoices',
    LOAD_BOARD: 'Load Board',
    MY_SHIPMENTS: 'My Shipments'
  }
}
